<template>
    <div class="card-avg-time-check-in px-3 py-3">
        <div class="header-average-time-check-in locale-font">
            <div class="header-text">
                {{$vuetify.lang.t('$vuetify.averageTimeCheckInGraph.averageTime')}}
            </div>
            <div class="dropdown-size">
                <v-select
                    v-model="selectedGroup"
                    @change="getGraphData"
                    :items="groupList"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                >
                </v-select>
            </div>
        </div>
        <line-chart
            v-if="show"
            :options="optionsLineCollection"
            :chart-data="dataLineCollection"
        ></line-chart>
    </div>
</template>

<script>
import LineChart from '@/components/Chart/LineChart.js'
export default {
    name: 'AverageTimeCheckInGraph',

    components: {
        LineChart
    },
    computed: {
        days () {
            return [
                this.$vuetify.lang.t('$vuetify.averageTimeCheckInGraph.mon'),
                this.$vuetify.lang.t('$vuetify.averageTimeCheckInGraph.tues'),
                this.$vuetify.lang.t('$vuetify.averageTimeCheckInGraph.wednes'),
                this.$vuetify.lang.t('$vuetify.averageTimeCheckInGraph.thurs'),
                this.$vuetify.lang.t('$vuetify.averageTimeCheckInGraph.fri'),
                this.$vuetify.lang.t('$vuetify.averageTimeCheckInGraph.satur'),
                this.$vuetify.lang.t('$vuetify.averageTimeCheckInGraph.sun')
            ]
        },
        dataLineCollection () {
            return this.initializeBarData()
        }
    },
    data () {
        return {
            show: false,
            groupList: [],
            averageTimeList: [],
            branchId: '',
            selectedGroup: '',
            optionsLineCollection: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            // one step = 1 hours
                            stepSize: 3600000,

                            callback: function (value, index, values) {
                                const dateTime = new Date(value)
                                // display time HH:MM
                                return dateTime.toLocaleTimeString('th-TH').slice(0, 5)
                            }
                        }
                    }]
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        label: function (tooltipsItem, data) {
                            const timeDisplay = new Date(tooltipsItem.yLabel)
                            // display time HH:MM
                            return timeDisplay.toLocaleTimeString('th-TH').slice(0, 5)
                        }
                    }
                },
                legend: {
                    display: false
                }
            }
        }
    },

    methods: {
        initializeBarData () {
            this.show = true
            return {
                labels: this.days,
                datasets: [
                    {
                        label: 'Average Time',
                        backgroundColor: '#6c98ba',
                        borderColor: '#6c98ba',
                        fill: false,
                        data: this.averageTimeList,

                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [{
                                    type: 'string'
                                }]
                            }
                        }
                    }
                ]
            }
        },

        async getBranch () {
            this.branchId = localStorage.getItem('currentBranchId')
            if (this.branchId) {
                await this.getGroupsInBranch(this.branchId)
            }
        },

        async getGroupsInBranch (branchId) {
            this.averageTimeList = []
            const res = await this.axios.get(`dashboard/getGroupList?branch=${branchId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.groupList = res.data.data
                if (this.groupList.length > 0) {
                    this.selectedGroup = this.groupList[0].id
                    await this.getGraphData()
                }
            }
        },

        async getGraphData () {
            this.show = false
            const res = await this.axios.get(`dashboard/getGraphAverage?branch=${this.branchId}&group=${this.selectedGroup}`)
            if (res && res.data && res.data.status === 'ok') {
                // format data to time stamp for add value to graph
                const times = res.data.data.map(time => {
                    // if avg is not null
                    if (time) {
                        return new Date(`1970-02-01 ${time}`).valueOf()
                    }
                    return null
                })

                this.averageTimeList = times
                this.show = true
            }
        }
    },

    async mounted () {
        this.branchId = localStorage.getItem('currentBranchId')
        if (this.branchId) {
            await this.getGroupsInBranch(this.branchId)
        }
        this.initializeBarData()
    },

    watch: {
        '$store.state.currentBranchId': async function (newValue) {
            if (newValue) {
                this.branchId = newValue
                await this.getGroupsInBranch(newValue)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.header-average-time-check-in {
    font-size: 24px;
    display: flex;
    justify-content: space-between;

    .header-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.card-avg-time-check-in {
    border-radius: 15px;
    box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
}
.dropdown-size {
    width: 40%;
    min-width: 100px;
}
</style>
